import jp from 'jsonpath';
import getFormLocal from './getFormLocal';

export default function getSections(formId) {
  const _formId = parseInt(formId, 10);
  return new Promise((resolve) => {
    getFormLocal(_formId)
      .then((form) => {
        if (form === undefined) resolve([]);
        resolve(jp.query(form, '$.inspection.children[*]'));
      })
      .then(() => {
        resolve([]);
      });
  });
}
